import React, { Component } from 'react'
import { Container, Col, Row } from 'reactstrap'
import { T } from '../traks'
import { A } from '../routes'
import { site_name } from '../Site'
import OurLogo from '../c/OurLogo'
import { using_cookiebot } from '../c/Cookiebot.js'

class Footer extends Component {
  render() {
    const our_logo = <OurLogo />

    let ad_sense_stuff = null

    return (
      <React.Fragment>
      {ad_sense_stuff}
      <Container fluid className="navbar-dark footer py-5 mt-auto">
        <Container className="text-center p-0">
        <img src="https://aktiedysten-static-v2.s3.eu-north-1.amazonaws.com/gfx/millionaerklubbens-aktiespil-footer.svg"/>
        <div className="d-flex flex-column pt-3">
          <a className="ad_footer_link text-center" href="https://www.berlingskemedia.dk/handelsbetingelser" target="_blank" rel="noopener noreferrer">
            Generelle handelsbetingelser
          </a>
          <a className="ad_footer_link text-center" href="https://www.berlingskemedia.dk/cookie-og-privatlivspolitik/" target="_blank" rel="noopener noreferrer">
            Cookie- og privatlivspolitik
          </a>
          <a className="ad_footer_link text-center" href="https://www.bt.dk/cookiedeklaration" target="_blank" rel="noopener noreferrer">
            Cookiedeklaration
          </a>
          <a className="ad_footer_link text-center" href="https://www.berlingskemedia.dk/ophavsret-og-vilkaar" target="_blank" rel="noopener noreferrer">
            Ophavsret og vilkår
          </a>
          <a className="ad_footer_link text-center" href="https://www.berlingskemedia.dk/konkurrencebetingelser" target="_blank" rel="noopener noreferrer">
            Konkurrencebetingelser
          </a>
        </div>
        </Container>
        <div className="font-m pt-3 text-center"> 
            <b className="fw-bold">Millionærklubbens Aktiespil</b> er udviklet og drevet af <b className="fw-bold">Aktiedysten</b>
          </div>
      </Container>
      </React.Fragment>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/c/Footer.js